import * as ACTIONS from "@iso/redux/specifications/actionTypes";

const initialState = {
  specifications: {
    list: [],
    total: 0,
  },
  fullSpecifications: [],
};

function specificationsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_SPECIFICATIONS_SUCCESS: {
      return {
        ...state,
        ...{ specifications: payload },
      };
    }

    case ACTIONS.GET_FULL_SPECIFICATIONS_SUCCESS: {
      return {
        ...state,
        ...{ fullSpecifications: payload },
      };
    }

    default:
      return state;
  }
}

export default specificationsReducer;
